<template>
    <v-card>
        <v-card v-if="smena1">
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="priyomsmena"
          :search="search"
          :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
          class="elevation-1"
          @dblclick:row="openSmena1"
          >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Открытые смены</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Поиск"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>

          <template v-slot:item.status_smena="{ item }">
              <v-icon v-if="item.status_smena==1" color="primary" >{{ getIcon(item.status_smena) }}</v-icon>
              <v-icon v-if="item.status_smena==2" color="error">{{ getIcon(item.status_smena) }}</v-icon>
              <v-icon v-if="item.status_smena==3" color="success" >{{ getIcon(item.status_smena) }}</v-icon>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" text @click="get_PriyomSmena">
              Обновить
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>


    <v-card v-if="smena_info">

        <v-card-title>
            <v-btn color="primary" icon @click="back">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-divider
                class="mx-4"
                inset
                vertical
                ></v-divider>
            Смена № {{ smena_info_obj.id_smena_org }}
                <v-divider
                class="mx-4"
                inset
                vertical
                ></v-divider>
                Кассир: {{ smena_info_obj.fio }}
                <v-divider
                class="mx-4"
                inset
                vertical
                ></v-divider>
                Статус: {{ smena_info_obj.status_smena_nom }}
                <v-divider
                class="mx-4"
                inset
                vertical
                ></v-divider>
                Дата открытии: {{ smena_info_obj.sana_ogoz }}





            <v-spacer></v-spacer>
            <v-btn color="error" icon @click="back">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>


        <div id="invoice-bot">

            <div id="table">
              <table>
                <tr class="tabletitle">
                  <td class="item"><h2>Вид операции</h2></td>
                  <td class="Hours"><h2>Всего</h2></td>
                  <td class="Hours"><h2>Скидки</h2></td>
                  <td class="Hours"><h2>Наличии</h2></td>
                  <td class="Hours"><h2>Долг</h2></td>
                  <td class="Hours"><h2>DCity</h2></td>
                  <td class="Hours"><h2>Эсхата</h2></td>
                  <td class="Hours"><h2>Алиф</h2></td>
                  <td class="Hours"><h2>Бонусный</h2></td>
                  <td class="subtotal"><h2>Итого</h2></td>
                </tr>

                <tr class="service">
                  <td class="tableitem"><p class="itemtext">Продажа</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.sum_furush) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.sum_skidka) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.nakd) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.sum_nasia) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.dc_sum)  }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.es_sum) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.al_sum) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.bn_sum) }}</p></td>
                  <td class="tableitem"><p class="itemtext"><strong>{{Number( Number(smena_info_obj.nakd) +Number(smena_info_obj.dc_sum) + Number(smena_info_obj.es_sum)+Number(smena_info_obj.al_sum) ).toFixed(2)  }}</strong></p></td>
                </tr>

                <tr class="service">
                  <td class="tableitem"><p class="itemtext">Возврат</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.sum_vozvrat) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.vozvrat_skidka) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.vozvrat_nakd) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.vozvrat_azkarz) }}</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext"><strong>{{ Number(smena_info_obj.vozvrat_nakd) }}</strong></p></td>
                </tr>

                <tr class="service">
                  <td class="tableitem"><p class="itemtext">Оплата долг</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.pard_n) + Number(smena_info_obj.pard_gnakd)  }}</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.pard_n) }}</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.pdc_sump) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.pes_sump)  }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.pal_sump) }}</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.pbn_sump) }}</p></td>
                  <td class="tableitem"><p class="itemtext"><strong>{{ Number(smena_info_obj.pard_n) +  Number(smena_info_obj.pdc_sump) + Number(smena_info_obj.pes_sump) +Number(smena_info_obj.pal_sump) }}</strong></p></td>
                </tr>

                <tr class="service">
                  <td class="tableitem"><p class="itemtext">Приход денег в кассу</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.sum_daromad)}}</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.sum_daromad)}}</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext"><strong>{{ Number(smena_info_obj.sum_daromad)}}</strong></p></td>
                </tr>

                <tr class="service">
                  <td class="tableitem"><p class="itemtext">Расход денег из кассы</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.sum_harojot)}}</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">{{ Number(smena_info_obj.sum_harojot)}}</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext">0</p></td>
                  <td class="tableitem"><p class="itemtext"><strong>{{ Number(smena_info_obj.sum_harojot)}}</strong></p></td>
                </tr>




                <tr class="tabletitle">

                  <!-- <td>{{ parseFloat( parseFloat(smena_info_obj.sum_furush) + parseFloat(smena_info_obj.sum_vozvrat) + parseFloat(smena_info_obj.pard_n) + parseFloat(smena_info_obj.pard_gnakd) +parseFloat(smena_info_obj.sum_daromad) + parseFloat(smena_info_obj.sum_harojot)).toFixed(2) }}</td>
                  <td>{{ parseFloat( parseFloat(smena_info_obj.sum_skidka) + parseFloat(smena_info_obj.vozvrat_skidka)).toFixed(2) }}</td> -->
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <!-- <td>{{ parseFloat(smena_info_obj.dc_sum) + parseFloat(smena_info_obj.pdc_sump) }}</td>
                  <td>{{ parseFloat( parseFloat(smena_info_obj.es_sum) + parseFloat(smena_info_obj.pes_sump)).toFixed(2) }}</td>
                  <td>{{ parseFloat(smena_info_obj.al_sum) + parseFloat(smena_info_obj.pal_sump)}}</td> -->
                  <td></td>
                  <td class="Rate"><h2>Итого:</h2></td>
                  <td class="payment">
                    <h2><strong>
                        {{Number((Number(smena_info_obj.nakd)  +
                            Number(smena_info_obj.dc_sum) +
                            Number(smena_info_obj.es_sum)+
                            Number(smena_info_obj.al_sum)+
                            Number(smena_info_obj.pard_n) +
                            Number(smena_info_obj.pard_gnakd) +
                            Number(smena_info_obj.sum_daromad) ) -
                            (Number(smena_info_obj.vozvrat_nakd) + Number(smena_info_obj.sum_harojot ) + Number(smena_info_obj.pbn_sump))).toFixed(2)
                            }}</strong></h2></td>
                </tr>

              </table>
            </div><!--End Table-->


          </div><!--End InvoiceBot-->





      </v-card>

      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>

    </v-card>
  </template>

  <script>
  export default {

      data: () => ({
          headers: [
          {
              text: '№',
              align: 'start',
              value: 'id_smena_org',
          },
          { text: 'Кассир', value: 'fio' },
          { text: 'Дата открытии', value: 'sana_ogoz' },
          { text: 'Сумма наличий', value: 'savdo_nakd' },
          { text: 'Статус', value: 'status_smena' },
          ],




          priyomsmena: [],
          smena: {},
          loading: false,

          snack: false,
          snackColor: '',
          snackText: '',

          search: '',

            smena1: true,
            smena_info: false,
            smena_info_obj: {},





      }),

      mounted(){
          this.get_PriyomSmena();
      },

      methods: {

          get_PriyomSmena(){

              this.loading = true;
              axios.get('/api/get_PriyomSmena/1',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.priyomsmena = response.data.priyomsmena;
                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения истории смен!"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });

          },

          getIcon (status_smena) {
          if (status_smena == 1) return 'mdi-lock-open-variant'
          else if (status_smena == 2) return 'mdi-lock'
          else if (status_smena == 3) return 'mdi-check-bold'
          else return 'mdi-file-question'
        },

        openSmena1(event, {item}){
            this.smena = item;
            // this.$emit('openSmena', this.smena);


            this.get_smena1(item.id_smena_org);
        },

        get_smena1(id_smena){
            this.loading = true;
            axios.get('/api/get_smena/'+id_smena,
                    {
                        headers: {
                            "Content-type": "application/json"
                        }
                    })
                    .then(response => {
                            if(response.data.status){
                                this.loading = false;
                                this.smena_info_obj = response.data.priyomsmena;
                                this.smena1 = false;
                                this.smena_info = true;

                            }else{
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = "Ошибка получения истории смен!"
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = error.response.data.message;
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                        });
        },

        back(){
            this.get_PriyomSmena();
            this.smena1 = true;
            this.smena_info = false;
        }

      }

  }
  </script>

<style  scoped>

@import url(https://fonts.googleapis.com/css?family=Roboto:100,300,400,900,700,500,300,100);
*{
  margin: 0;
  box-sizing: border-box;

}
body{

  font-family: 'Roboto', sans-serif;

  background-repeat: repeat-y;
  background-size: 100%;
}
::selection {background: #f31544; color: #FFF;}
::moz-selection {background: #f31544; color: #FFF;}
h1{
  font-size: 1.5em;
  color: #222;
}
h2{font-size: .9em;}
h3{
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
}
p{
  font-size: .7em;
  color: #666;
  line-height: 1.2em;
}

#invoiceholder{
  width:100%;
  hieght: 100%;
  padding-top: 50px;
}
#headerimage{
  z-index:-1;
  position:relative;
  top: -50px;
  height: 350px;
  background-image: url('http://michaeltruong.ca/images/invoicebg.jpg');

  -webkit-box-shadow:inset 0 2px 4px rgba(0,0,0,.15), inset 0 -2px 4px rgba(0,0,0,.15);
	-moz-box-shadow:inset 0 2px 4px rgba(0,0,0,.15), inset 0 -2px 4px rgba(0,0,0,.15);
	box-shadow:inset 0 2px 4px rgba(0,0,0,.15), inset 0 -2px 4px rgba(0,0,0,.15);
  overflow:hidden;
  background-attachment: fixed;
  background-size: 1920px 80%;
  background-position: 50% -90%;
}
#invoice{
  position: relative;
  top: -290px;
  margin: 0 auto;
  width: 700px;
  background: #FFF;
}

[id*='invoice-']{ /* Targets all id with 'col-' */
  border-bottom: 1px solid #EEE;
  padding: 30px;
}

#invoice-top{min-height: 120px;}
#invoice-mid{min-height: 120px;}
#invoice-bot{ min-height: 250px;}

.logo{
  float: left;
	height: 60px;
	width: 60px;
	background: url(http://michaeltruong.ca/images/logo1.png) no-repeat;
	background-size: 60px 60px;
}
.clientlogo{
  float: left;
	height: 60px;
	width: 60px;
	background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
	background-size: 60px 60px;
  border-radius: 50px;
}
.info{
  display: block;
  float:left;
  margin-left: 20px;
}
.title{
  float: right;
}
.title p{text-align: right;}
#project{margin-left: 52%;}
table{
  width: 100%;
  border-collapse: collapse;
}
td{
  padding: 5px 0 5px 15px;
  border: 1px solid #EEE
}
.tabletitle{
  padding: 5px;
  background: #EEE;
}
.service{border: 1px solid #EEE;}
.item{width: 20%;}
.itemtext{font-size: .9em;}

#legalcopy{
  margin-top: 30px;
}
form{
  float:right;
  margin-top: 30px;
  text-align: right;
}


.effect2
{
  position: relative;
}
.effect2:before, .effect2:after
{
  z-index: -1;
  position: absolute;
  content: "";
  bottom: 15px;
  left: 10px;
  width: 50%;
  top: 80%;
  max-width:300px;
  background: #777;
  -webkit-box-shadow: 0 15px 10px #777;
  -moz-box-shadow: 0 15px 10px #777;
  box-shadow: 0 15px 10px #777;
  -webkit-transform: rotate(-3deg);
  -moz-transform: rotate(-3deg);
  -o-transform: rotate(-3deg);
  -ms-transform: rotate(-3deg);
  transform: rotate(-3deg);
}
.effect2:after
{
  -webkit-transform: rotate(3deg);
  -moz-transform: rotate(3deg);
  -o-transform: rotate(3deg);
  -ms-transform: rotate(3deg);
  transform: rotate(3deg);
  right: 10px;
  left: auto;
}



.legal{
  width:70%;
}
</style>



